// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__eX8GW","productName":"Table_productName__1NaA_"};